// @flow

export const categories = {
    HUE: 'hue',
    ZONE: 'zone',
    DEVICE: 'device'
};



// WEBPACK FOOTER //
// ./src/core/components/widgets/remove-device/constants.js